<template>
  <div>
    <a-button type="primary" icon="plus" @click="open">添加酒水</a-button>

    <a-modal
        v-model="visible"
        title="添加酒水"
        :width="640"
        @cancel="close"
        @ok="handleAdd"
        destroyOnClose
    >
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :colon="false">
        <a-form-item label="类型">
          <a-select
              @change="onTypeChange"
              v-decorator="['typeInv', { rules: [{ required: true, message: '请选择！' }] }]"
              placeholder="请选择"
          >
            <a-select-option
                v-for="item in typeList"
                :key="item.value"
                :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="子类型">
          <a-select
              @change="onSubTypeChange"
              v-decorator="['typeSub', { rules: [{ required: true, message: '请选择！' }] }]"
              placeholder="请选择"
          >
            <a-select-option
                v-for="item in subTypeList"
                :key="item.value"
                :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="酒水品名">
          <a-auto-complete
              v-decorator="['name', { rules: [{ required: true, message: '请输入！' }] }]"
              :dataSource="nameList"
              placeholder="请选择或输入"
              :filterOption="filterOption"
              @change="onNameChange"
              allowClear
          />
        </a-form-item>
        <a-form-item label="单位">
          <a-select
              v-decorator="['unit', { rules: [{ required: true, message: '请选择！' }] }]"
              placeholder="请选择"
          >
            <a-select-option
                v-for="item in unitList"
                :key="item.value"
                :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="单价(元)">
          <a-input-number
              :min="0"
              style="width: 100%"
              v-decorator="['unitPrice', { rules: [{ required: true, message: '请输入！' }] }]"
              placeholder="请输入"
          />
        </a-form-item>
        <a-form-item label="数量">
          <a-input-number
              :min="1"
              style="width: 100%"
              v-decorator="['quantity', { rules: [{ required: true, message: '请输入！' }] }]"
              placeholder="请输入"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchList } from "@/api/oa/material";

export default {
  name: "WineAdd",

  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      subTypeList: [],
      nameList: [],
      nameOptions: [],
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("invType");
    },
    unitList() {
      return this.findDataDict("invUnit");
    },
  },

  methods: {
    open() {
      this.subTypeList = [];
      this.nameList = [];
      this.nameOptions = [];
      this.form.resetFields();
      this.visible = true;
    },

    close() {
      this.visible = false;
    },

    /** 类型切换 → 更新子类型列表，清空品名，尝试拉取品名 */
    onTypeChange(value) {
      if (value) {
        const obj = this.typeList.find((item) => item.value === value);
        this.subTypeList = obj && Array.isArray(obj.children) ? obj.children : [];
      } else {
        this.subTypeList = [];
      }
      this.form.setFieldsValue({ typeSub: undefined, name: undefined });
      this.nameList = [];
      this.nameOptions = [];
      this.loadNames(value, undefined);
    },

    /** 子类型切换 → 拉取品名列表 */
    onSubTypeChange(value) {
      const typeInv = this.form.getFieldValue('typeInv');
      this.form.setFieldsValue({ name: undefined });
      this.nameList = [];
      this.nameOptions = [];
      this.loadNames(typeInv, value);
    },

    /** 调用接口获取品名列表 */
    loadNames(typeInv, typeSub) {
      if (!typeInv) {
        this.nameList = [];
        this.nameOptions = [];
        return;
      }
      const params = { typeInv, pageSize: 999 };
      if (typeSub) params.typeSub = typeSub;
      fetchList(params).then((res) => {
        const data = (res && Array.isArray(res.list)) ? res.list : [];
        this.nameOptions = data.map((item) => ({
          id: item.id || '',
          name: item.name || '',
          unit: item.unit || undefined,
          unitPrice: item.unitPrice || undefined,
        }));
        this.nameList = this.nameOptions.map((item) => item.name);
      });
    },

    /** auto-complete 过滤：输入时筛选下拉 */
    filterOption(inputValue, option) {
      return option.componentOptions.children[0].text
          .toLowerCase()
          .includes(inputValue.toLowerCase());
    },

    /** 品名变化时自动带入单位、单价 */
    onNameChange(value) {
      const found = this.nameOptions.find((item) => item.name === value);
      if (found) {
        this.form.setFieldsValue({
          unit: found.unit,
          unitPrice: found.unitPrice,
        });
      }
    },

    resolveSubName(parentObj, subValue) {
      if (!parentObj || !subValue) return '';
      const children = parentObj.children || [];
      const found = children.find((item) => item.value === subValue);
      return found ? found.name : subValue;
    },

    resolveUnitName(value) {
      if (!value) return '';
      const list = this.findDataDict("invUnit") || [];
      const found = list.find((item) => item.value === value);
      return found ? found.name : value;
    },

    handleAdd() {
      this.form.validateFields((err, values) => {
        if (err) return;

        const found = this.nameOptions.find((item) => item.name === values.name);
        const typeObj = this.typeList.find((item) => item.value === values.typeInv);
        this.$emit("add", {
          materialId: found ? found.id : '',
          name: values.name,
          quantity: values.quantity,
          typeInv: values.typeInv,
          typeInvName: typeObj ? typeObj.name : values.typeInv,
          typeSub: values.typeSub,
          typeSubName: this.resolveSubName(typeObj, values.typeSub),
          unit: values.unit,
          unitName: this.resolveUnitName(values.unit),
          unitPrice: values.unitPrice,
        });
        this.visible = false;
      });
    },
  },
};
</script>
